// eslint-disable-next-line import/no-cycle
import platformService from '../../core/services/platform.service';
import { SET, LOADING } from './agenda.types';

export function setAgenda(agenda) {
  return {
    type: SET,
    agenda,
  };
}

export function fetchAgenda() {
  return async (dispatch) => {
    dispatch({ type: LOADING });
    const { agenda } = await platformService.fetchAgenda();
    if (agenda) {
      dispatch(setAgenda(agenda));
    }
  };
}
